export const URL_ENV =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_API_BASEPATH || "https://api.azulfy.app"
    : process.env.NEXT_PUBLIC_API_LOCAL_BASEPATH ||
      process.env.NEXT_PUBLIC_API_BASEPATH;
export const TOAST_DURATION = 8000;
export const FILTER_OPTIONS = [
  "all",
  "global",
  "air",
  "water",
  "soil",
  /*"micro"*/
];

export const resolveTypeFilter = (
  label: string,
): { type?: string; area_name?: string; area_name_contains?: string } => {
  const map: Record<
    string,
    { type?: string; area_name?: string; area_name_contains?: string }
  > = {
    air: { type: "air station" },
    water: { type: "water station" },
    soil: { type: "soil station" },
    /*micro: { type: "micro area" },*/
    global: { area_name_contains: "global" },
    all: {},
  };
  return map[label.toLowerCase()] || {};
};
